export * from './auth/auth.service';
export * from './questionari.service'
export * from './contenuti.service';
export * from './percorso.service';
export * from './risultati.service';
export * from './competenze.service';
export * from './moduli.service';